import { css, Interpolation, Theme } from '@emotion/react'

export const container = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1190px;
  padding: 24px;
  margin: 0 auto;
`

export const containerPadding: Interpolation<Theme> = (theme) => css`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1190px;
  margin: 0 auto;
  padding: 0 ${theme.spacing(3)};
`

export const formContainer = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1190px;
  margin: 0 auto;
`

export const formContainerPadding = css`
  padding-bottom: 48px;
`

export const containerMargin = css`
  margin-top: -18px;
`

export const contentContainer = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 24px;
`

export const block = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  max-width: 850px;
`

export const title = (theme: Theme) => css`
  color: ${theme.typographyColors.typographyTwo};
  font-weight: 700;
  margin: 24px 0;
`

export const subtitle = (theme: Theme) => css`
  color: ${theme.typographyColors.typographyTwo};
  font-weight: 700;
`

export const videoPlayer = css`
  width: 850px;
  height: auto;
  aspect-ratio: 16/9;
  border-radius: 14px;
  overflow: hidden;
`
